import React, { useEffect, useState, useMemo } from "react";
import Pagelayout from "../../components/Pagelayout";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomTable from "../../components/ListPageComponent";
import { viewLeaveApplicationsAPICall, approveLeaveApplicationsAPICall } from "../../../../../API/Staff/HRM/Leave/staffLeaveApplicationAPI";
import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { Print as PrintIcon } from "@mui/icons-material";
import Swal from "sweetalert2";
import axios from "axios";
import { HEADERS } from "../../../../../API/UrlAndPaths";



const PayrollLeave = () => {
  const navigate = useNavigate();
  const userMeta = localStorage.getItem('login_meta');
  const userBranchId = JSON.parse(userMeta)?.branchId;
  
  const [isLoading, setIsLoading] = useState(false);
  const [isModify, setIsModify] = useState(false);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [leaveTypeMap, setLeaveTypeMap] = useState({});
  
  const leaveApplications = useSelector((state) => state.allLeaveApplicationSlice.value);
  
  const handleCreateBtn = () => {
    navigate("create");
  };

  // Print functions
  const handlePrintList = () => {
    const printWindow = window.open('', '_blank');
    const printStyles = `
      <style>
        body { font-family: Arial, sans-serif; margin: 20px; }
        .header { text-align: center; margin-bottom: 30px; }
        .header h2 { margin-bottom: 10px; }
        .header p { color: #666; }
        table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
        th { background-color: #f5f5f5; font-weight: bold; }
        td img { width: 40px; height: 40px; border-radius: 50%; object-fit: cover; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .status-chip { padding: 4px 8px; border-radius: 12px; font-size: 12px; font-weight: bold; }
        .status-pending { background-color: #fff3e0; color: #f57c00; }
        .status-approved { background-color: #e8f5e8; color: #2e7d32; }
        .status-rejected { background-color: #ffebee; color: #c62828; }
        @media print { body { margin: 10px; } }
      </style>
    `;
    
    const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Leave Applications Report</title>
          ${printStyles}
        </head>
        <body>
          <div class="header">
            <h2>LEAVE APPLICATIONS REPORT</h2>
            <p>Generated on ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}</p>
          </div>
          
          <table>
            <thead>
              <tr>
                <th>Image</th>
                <th>Employee</th>
                <th>Emp ID</th>
                <th>Leave Type</th>
                <th>From</th>
                <th>To</th>
                <th>Days</th>
                <th>Reason</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              ${formattedData.map(leave => {
                const statusClass = leave.status.toLowerCase();
                
                // Extract image URL from the original leave data
                const rawImg = 
                  leave.imageUrl ||
                  leave.profileImage ||
                  leave.image ||
                  leave.employeePhoto ||
                  "";
                const base = axios.defaults.baseURL || "";
                const imageUrl = rawImg && rawImg !== base
                  ? (rawImg.startsWith("http") ? rawImg : `${base}${rawImg.startsWith("/") ? "" : "/"}${rawImg}`)
                  : null;
                
                return `
                  <tr>
                    <td class="text-center">
                      ${imageUrl ? 
                        `<img src="${imageUrl}" alt="${leave.employeeName || 'Employee'}" onerror="this.style.display='none'">` : 
                        '<div style="width:40px;height:40px;background:#f0f0f0;border-radius:50%;margin:0 auto;"></div>'
                      }
                    </td>
                    <td>${leave.employeeName}</td>
                    <td>${leave.employeeId}</td>
                    <td>${leave.leaveType}</td>
                    <td>${leave.DateFrom}</td>
                    <td>${leave.DateTo}</td>
                    <td class="text-center">${leave.days}</td>
                    <td>${leave.reason || '-'}</td>
                    <td class="text-center">
                      <span class="status-chip status-${statusClass}">
                        ${leave.status}
                      </span>
                    </td>
                  </tr>
                `;
              }).join('')}
            </tbody>
          </table>
          
          <div style="margin-top: 30px; text-align: center;">
            <p><strong>Total Applications:</strong> ${formattedData.length}</p>
            <p style="color: #666; font-size: 12px;">This is a computer generated report</p>
          </div>
        </body>
      </html>
    `;
    
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  const handlePrintSingle = () => {
    if (!selectedLeave) return;
    
    const printWindow = window.open('', '_blank');
    const printStyles = `
      <style>
        body { font-family: Arial, sans-serif; margin: 20px; }
        .header { text-align: center; margin-bottom: 30px; }
        .info-section { margin-bottom: 20px; }
        .info-row { display: flex; justify-content: space-between; margin-bottom: 10px; }
        .info-label { font-weight: bold; min-width: 120px; }
        .info-value { flex: 1; }
        .status-section { padding: 15px; background: #f5f5f5; border-radius: 5px; margin-bottom: 20px; }
        .status-badge { padding: 8px 16px; border-radius: 20px; font-weight: bold; text-align: center; }
        .status-pending { background-color: #fff3e0; color: #f57c00; }
        .status-approved { background-color: #e8f5e8; color: #2e7d32; }
        .status-rejected { background-color: #ffebee; color: #c62828; }
        @media print { body { margin: 10px; } }
      </style>
    `;
    
    const statusClass = selectedLeave.status.toLowerCase();
    
    const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Leave Application Details - ${selectedLeave.employeeName}</title>
          ${printStyles}
        </head>
        <body>
          <div class="header">
            <h2>LEAVE APPLICATION DETAILS</h2>
            <p>Generated on ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}</p>
          </div>
          
          <div class="info-section">
            <div class="info-row">
              <span class="info-label">Employee ID:</span>
              <span class="info-value">${selectedLeave.employeeId}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Employee Name:</span>
              <span class="info-value">${selectedLeave.employeeName}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Leave Type:</span>
              <span class="info-value">${selectedLeave.leaveType}</span>
            </div>
            <div class="info-row">
              <span class="info-label">From Date:</span>
              <span class="info-value">${selectedLeave.DateFrom}</span>
            </div>
            <div class="info-row">
              <span class="info-label">To Date:</span>
              <span class="info-value">${selectedLeave.DateTo}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Number of Days:</span>
              <span class="info-value">${selectedLeave.days}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Reason:</span>
              <span class="info-value">${selectedLeave.reason || '-'}</span>
            </div>
          </div>
          
          <div class="status-section">
            <h3 style="margin-top: 0;">Application Status</h3>
            <div class="status-badge status-${statusClass}">
              ${selectedLeave.status}
            </div>
          </div>
          
          <div style="margin-top: 40px; text-align: center;">
            <p style="color: #666;">This is a computer generated leave application record</p>
          </div>
        </body>
      </html>
    `;
    
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  
  const handleLeaveBalanceBtn = () => {
    navigate("/userdashboard/payroll/attendance/LeaveBalance");
  };

  const headers = [
    { key: "employeeImage", label: "Image", width: 56 },
    { key: "employeeName", label: "Employee" },
    { key: "employeeId", label: "Emp ID" },
    { key: "leaveType", label: "Leave Type" },
    { key: "DateFrom", label: "From" },
    { key: "DateTo", label: "To" },
    { key: "days", label: "Days" },
    { key: "reason", label: "Reason" },
    { key: "status", label: "Status" },
    { key: "actions", label: "Actions" },
  ];

  const visibleColumns = [
    "employeeImage",
    "employeeName",
    "employeeId",
    "leaveType",
    "DateFrom",
    "DateTo",
    "days",
    "reason",
    "status",
    "actions",
  ];
  
  // Fetch leave applications
  useEffect(() => {
    // Use actual branch ID, not 'noBranch'
    // Try to get from localStorage or default to RAKRA1
    const storedBranch = localStorage.getItem('BRANCH_ID');
    const actualBranchId = userBranchId === 'noBranch' ? (storedBranch || 'RAKRA1') : userBranchId;
    if (actualBranchId) {
      console.log('Fetching leave applications for branch:', actualBranchId);
      viewLeaveApplicationsAPICall({ branchId: actualBranchId }, setIsLoading);
    }
  }, [userBranchId, isModify]);

  // Debug: Log leave applications when they change
  useEffect(() => {
    console.log('📋 Payroll: Leave applications updated from Redux:', leaveApplications?.length || 0, 'records');
    if (leaveApplications && leaveApplications.length > 0) {
      console.log('   First leave application data:', leaveApplications[0]);
      console.log('   Latest leave application:', leaveApplications[leaveApplications.length - 1]);
    }
  }, [leaveApplications]);

  // Fetch leave types (id -> name) for display
  useEffect(() => {
    const fetchLeaveTypes = async () => {
      try {
        const res = await axios.get("employee/viewLeaveType", HEADERS);
        if (res.status === 200) {
          const list = res.data?.data || res.data || [];
          const map = (list || []).reduce((acc, lt) => {
            acc[lt._id] = lt.leaveType || lt.name || lt.code || lt._id;
            return acc;
          }, {});
          setLeaveTypeMap(map);
        }
      } catch (e) {
        // silent fail - fallback to showing id
        console.error("Failed to load leave types", e);
      }
    };
    fetchLeaveTypes();
  }, []);
  
  // Helper: get human-readable leave type label
  const getLeaveTypeLabel = (lt) => {
    if (!lt) return '';
    if (typeof lt === 'object') {
      return lt.leaveType || lt.name || lt.code || lt._id || '';
    }
    return leaveTypeMap[lt] || lt; // lt is assumed to be ID or name
  };

  // Memoized image component to prevent re-renders
  const EmployeeImage = useMemo(() => {
    // Inline SVG placeholder (40x40 circle) eliminates network 404 loops
    const FALLBACK_DATA_URL =
      'data:image/svg+xml;utf8,' +
      encodeURIComponent(
        `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
          <rect width="40" height="40" fill="#f0f0f0"/>
          <circle cx="20" cy="15" r="8" fill="#c0c0c0"/>
          <rect x="10" y="26" width="20" height="8" rx="4" fill="#d0d0d0"/>
        </svg>`
      );

    return ({ src, alt }) => (
      <img
        src={src || FALLBACK_DATA_URL}
        alt={alt}
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          objectFit: 'cover',
          border: '1px solid #e0e0e0'
        }}
        onError={(e) => {
          // Prevent infinite onError loop by removing handler, then set fallback
          e.currentTarget.onerror = null;
          e.currentTarget.src = FALLBACK_DATA_URL;
        }}
      />
    );
  }, []);

  // Format data for table with deduplication
  const formattedData = useMemo(() => {
    // Deduplicate by _id to prevent duplicate rows
    const uniqueLeaves = (leaveApplications || []).reduce((acc, leave) => {
      if (!acc.some(l => l._id === leave._id)) {
        acc.push(leave);
      }
      return acc;
    }, []);
    
    // Sort by appliedDate descending (newest first)
    const sortedLeaves = uniqueLeaves.sort((a, b) => {
      const dateA = new Date(a.appliedDate || a.DateFrom || 0);
      const dateB = new Date(b.appliedDate || b.DateFrom || 0);
      return dateB - dateA; // Newest first
    });
    
    return sortedLeaves.map((leave) => {
    // Get the best image URL
    const imageUrl = 
      (leave.imageUrl && leave.imageUrl !== 'http://192.168.1.55:3100/' ? leave.imageUrl : null) ||
      (leave.profileImage && leave.profileImage !== 'http://192.168.1.55:3100/' ? leave.profileImage : null) ||
      (leave.image && leave.image !== 'http://192.168.1.55:3100/' ? leave.image : null) ||
      (leave.employeePhoto && leave.employeePhoto !== 'http://192.168.1.55:3100/' ? leave.employeePhoto : null) ||
      null;

    return {
      ...leave,
      employeeImage: <EmployeeImage src={imageUrl} alt={leave.employeeName || 'Employee'} />,
      leaveType: getLeaveTypeLabel(leave.leaveType),
      // Keep status as string - TableStatusLabel will handle the display
      status: leave.status || 'PENDING',
      actions: (
      <div style={{ display: 'flex', gap: '8px' }}>
        {leave.status === 'PENDING' && (
          <>
            <Button 
              variant="contained" 
              color="success" 
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                handleApprove(leave);
              }}
            >
              Approve
            </Button>
            <Button 
              variant="contained" 
              color="error" 
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                handleReject(leave);
              }}
            >
              Reject
            </Button>
          </>
        )}
        <Button 
          variant="outlined" 
          startIcon={<PrintIcon />}
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setSelectedLeave(leave);
            handlePrintSingle();
          }}
        >
          Print
        </Button>
      </div>
    ),
    };
  });
  }, [leaveApplications, leaveTypeMap, EmployeeImage]);
  
  const handleRowClick = (rowData) => {
    setSelectedLeave(rowData);
    setDialogOpen(true);
  };
  
  const handleApprove = async (leave) => {
    const result = await Swal.fire({
      title: 'Approve Leave?',
      text: `Approve ${leave.days} days leave for ${leave.employeeName}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, approve it!'
    });
    
    if (result.isConfirmed) {
      await approveLeaveApplicationsAPICall({ _id: leave._id, type: 0 });
      setIsModify(!isModify);
      Swal.fire('Approved!', 'Leave has been approved.', 'success');
    }
  };
  
  const handleReject = async (leave) => {
    const result = await Swal.fire({
      title: 'Reject Leave?',
      text: `Reject ${leave.days} days leave for ${leave.employeeName}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, reject it!'
    });
    
    if (result.isConfirmed) {
      await approveLeaveApplicationsAPICall({ _id: leave._id, type: 1 });
      setIsModify(!isModify);
      Swal.fire('Rejected!', 'Leave has been rejected.', 'error');
    }
  };
  return (
    <Pagelayout pageName={"Leave Applications"} headerLayout={1} handleCreateBtn={handleCreateBtn} >
      {/* Header Buttons */}
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Button 
          variant="outlined" 
          startIcon={<PrintIcon />}
          onClick={handlePrintList}
          disabled={formattedData.length === 0}
          sx={{ mr: 2 }}
        >
          Print List
        </Button>
        <Button 
          variant="contained" 
          color="primary"
          onClick={handleLeaveBalanceBtn}
        >
          View Leave Balance
        </Button>
      </Box>
      
      <CustomTable
        headers={headers}
        data={formattedData}
        visibleColumns={visibleColumns}
        onRowClick={handleRowClick}
        loading={isLoading}
        key="payroll-leave-table"
      />
      
      {/* Leave Details Dialog */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Leave Details</DialogTitle>
        <DialogContent>
          {selectedLeave && (
            <div style={{ padding: '16px' }}>
              <p><strong>Employee:</strong> {selectedLeave.employeeName}</p>
              <p><strong>Employee ID:</strong> {selectedLeave.employeeId}</p>
              <p><strong>Leave Type:</strong> {getLeaveTypeLabel(selectedLeave.leaveType)}</p>
              <p><strong>From:</strong> {selectedLeave.DateFrom}</p>
              <p><strong>To:</strong> {selectedLeave.DateTo}</p>
              <p><strong>Days:</strong> {selectedLeave.days}</p>
              <p><strong>Reason:</strong> {selectedLeave.reason}</p>
              <p><strong>Applied Date:</strong> {selectedLeave.appliedDate}</p>
              <p><strong>Status:</strong> {selectedLeave.status}</p>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={handlePrintSingle}
            disabled={!selectedLeave}
          >
            Print
          </Button>
          <Button onClick={() => setDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Pagelayout>
  );
};

export default PayrollLeave;




